/**
 *
 * Asynchronously loads the component for AssetsDashboard
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetsDashboard = lazyLoad(
  () => import('./index'),
  module => module.AssetsDashboard,
);
